import React, { useEffect } from 'react';
import axios from 'axios';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './Components/Navbar';
import AdminNavbar from './Components/AdminNavbar';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import Admin from './Pages/Admin';
import Categories from './Pages/Categories';
import Definitions from './Pages/Definitions';
import Products from './Pages/Products';
import Shop from './Pages/Shop';
import Orders from './Pages/Orders';
import Cart from './Pages/Cart';
import Discounts from './Pages/Discounts';
import SocialMedia from './Pages/SocialMedia';
import { AdminProvider } from './Context/AdminContext';
import { UserProvider } from './Context/UserContext';
import { CartProvider } from './Context/CartContext';
import Auth from './Pages/Auth';
import Wishlist from './Pages/Wishlist';
import AnnouncementBar from './Components/AnnouncementBar';
import AdminOrders from './Pages/AdminOrders';
import Profile from './Pages/Profile';
import AdminUsers from './Pages/AdminUsers';
import AdminLogin from './Pages/AdminLogin';
import ProtectedRoute from './Components/ProtectedRoute';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const NavigationWrapper = () => {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin') && location.pathname !== '/admin/login';

  const token = localStorage.getItem('adminToken');
  let adminUser = null;
  try {
    adminUser = JSON.parse(localStorage.getItem('adminUser'));
  } catch (error) {
    adminUser = null;
  }

  const isAdminAuthenticated = token && adminUser && token !== 'null' && token !== 'undefined';

  if (isAdminPath && isAdminAuthenticated) return <AdminNavbar />;

  return (
    <>
      <AnnouncementBar />
      <Navbar />
    </>
  );
};

const FooterWrapper = () => {
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith('/admin');

  if (isAdminPath) return null;

  return <Footer />;
};

const App = () => {
  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          const isAdminPath = window.location.pathname.startsWith('/admin');
          if (isAdminPath && window.location.pathname !== '/admin/login') {
            localStorage.removeItem('adminToken');
            localStorage.removeItem('adminUser');
            window.location.replace('/admin/login');
          }
        }
        return Promise.reject(error);
      }
    );

    const isAdminPath = window.location.pathname.startsWith('/admin');
    const token = localStorage.getItem('adminToken');
    const adminUser = localStorage.getItem('adminUser');
    if (isAdminPath && window.location.pathname !== '/admin/login' && (!token || !adminUser || token === 'null' || token === 'undefined')) {
      window.location.replace('/admin/login');
    }

    return () => axios.interceptors.response.eject(interceptor);
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <UserProvider>
        <CartProvider>
          <AdminProvider>
            <NavigationWrapper />
            <main className="app-content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/admin/login" element={<AdminLogin />} />

                {/* Protected Admin Routes */}
                <Route path="/admin/*" element={<ProtectedRoute />}>
                  <Route index element={<Admin />} />
                  <Route path="categories" element={<Categories />} />
                  <Route path="definitions" element={<Definitions />} />
                  <Route path="products" element={<Products />} />
                  <Route path="discounts" element={<Discounts />} />
                  <Route path="social-media" element={<SocialMedia />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="users" element={<AdminUsers />} />
                </Route>

                <Route path="/shop" element={<Shop />} />
                <Route path="/orders" element={<Orders />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/profile" element={<Profile />} />
              </Routes>
            </main>
            <FooterWrapper />
          </AdminProvider>
        </CartProvider>
      </UserProvider>
    </Router>
  );
};

export default App;

